import { render, staticRenderFns } from "./GameSuggest.vue?vue&type=template&id=c4c1ef84&scoped=true"
import script from "./GameSuggest.vue?vue&type=script&lang=ts"
export * from "./GameSuggest.vue?vue&type=script&lang=ts"
import style0 from "./GameSuggest.vue?vue&type=style&index=0&id=c4c1ef84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c1ef84",
  null
  
)

export default component.exports